import { withDefaults } from '@warp-drive/legacy/model/migration-support';

// prettier-ignore
const ObservableAssetSchema = withDefaults({
  'type': 'observable-asset',
  'traits': ['digital-asset'],
  'fields': [
    {
      'kind': 'attribute',
      'name': 'externalUrl'
    },
    {
      'kind': 'belongsTo',
      'name': 'observableDocument',
      'type': 'observable-document',
      'options': {
        'async': false,
        'inverse': 'observableAsset'
      }
    }
  ]
});

export default ObservableAssetSchema;
